import { useQuery } from 'react-query';
import type { WorkspaceInvitation } from 'types/workspace.types';
import { WorkspaceCacheKeys } from 'types/cacheKeys.types';
import { getReceivedWorkspaceInvitations } from 'api/v3/access/accountantsAuth';
import useWorkspaceDetails from 'hooks/useWorkspaceDetails';

interface UseReceivedWorkspaceInvitationsReturn {
  invitations: WorkspaceInvitation[];
  invitationsCount: number;
  isLoading: boolean;
  error: unknown;
  refetch: () => void;
}

/**
 * Hook to fetch pending workspace invitations for the current user
 */
export const useReceivedWorkspaceInvitations =
  (): UseReceivedWorkspaceInvitationsReturn => {
    const { userEmail } = useWorkspaceDetails();

    const query = useQuery({
      queryKey: [WorkspaceCacheKeys.ReceivedInvitations, userEmail],
      queryFn: getReceivedWorkspaceInvitations,
      enabled: !!userEmail,
      select: (data) => ({
        invitations: data?.invitations || [],
        invitationsCount: data?.invitations?.length || 0,
      }),
    });

    return {
      invitations: query.data?.invitations || [],
      invitationsCount: query.data?.invitationsCount || 0,
      isLoading: query.isLoading,
      error: query.error,
      refetch: query.refetch,
    };
  };
